import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TalkService {
  private http = inject(HttpClient);

  private baseUrl = `${environment.apiUrl}/talk`;

  createTalk(data: any) {
    return this.http.post(this.baseUrl, data);
  }

  getAllTalks() {
    return this.http.get(this.baseUrl);
  }

  getTalk(id: string) {
    return this.http.get(`${this.baseUrl}/${id}`);
  }
}